<template></template>

<script>
    import ModelPanel from '../modeling/ModelPanel'
    var jsondiffpatch = require('jsondiffpatch').create({
        objectHash: function (obj, index) {
            return '$$index:' + index;
        },
    });

    export default {
        mixins: [ModelPanel],
        name: 'uml-property-panel',
        props: {
            img: String,
            entities: Object,
        },
        data: function () {
            return {
                canvasbase: null,
            }
        },
        computed: {
        },
        beforeDestroy() {
            var me = this
            if(!me.canvasbase.embedded) {
                me.executeBeforeDestroy()
            }
        },
        created: function () {
            var me = this
            me.canvasbase = me.getComponent('uml-class-model-canvas')
            if(!me.canvasbase.embedded) {
                me.panelInit()
            }
        },
        watch: {
        },
        methods:{
            panelInit(){
                var me = this
                // Element
                if(me.value.relationView && me.value._type.includes('Relation')) {
                    if(me.value.sourceElement.groupElement != me.value.targetElement.groupElement) {
                        me.value.relationType = 'org.uengine.uml.model.Aggregation'
                    }
                }
                // Common
                if (me.canvasbase.isServerModeling
                    && me.canvasbase.isQueueModeling
                    && !me.canvasbase.isClazzModeling
                    && !me.canvasbase.isReadModeling
                ) {
                    me.panelOpenQueue()
                }
            },
            executeBeforeDestroy() {
                var me = this
                try{
                    /*
                        _value : 기존 값.
                        value  : Panel 사용되는 값,
                    */
                    var diff = jsondiffpatch.diff(me._value, me.value)
                    if (diff) {
                        console.log('Panel - executeBeforeDestroy')
                        if (!me.readOnly) {
                            me.canvasbase.changedByMe = true
                            // all sync
                            Object.keys(me.value).forEach(function (itemKey) {
                                if(itemKey != 'elementView' || itemKey != 'relationView'){
                                    // Exception: 위치정보
                                    me._value[itemKey] = JSON.parse(JSON.stringify(me.value[itemKey]))
                                }
                            })
                            // re setting 값을 emit
                            me.$emit('_value-change', me._value)
                        }
                    }

                    if (me.canvasbase.isServerModeling
                        && me.canvasbase.isQueueModeling
                        && !me.canvasbase.isClazzModeling
                        && !me.canvasbase.isReadModeling
                    ) {
                        me.panelCloseQueue()
                    }
                }catch (e) {
                    alert('[Error] EventStormingPanel Sync: ', e)
                }
            },
        },
    }
</script>
